module.exports = __webpack_public_path__ + "img/default-crypto.205475ce.svg";